/**
 * Clears the whole cart after N hours of no cart activity (rolling —
 * every add/quantity-change/remove resets the clock, so it only fires
 * once the cart has genuinely been left untouched that long). On/off
 * and the hour count are both set in Theme settings > Cart Auto-Clear
 * (layout/theme.liquid exposes them as window.cwipCartAutoExpireSettings
 * since Liquid settings aren't otherwise readable from a plain JS file).
 *
 * Shopify has no built-in "expire this cart" setting and no way to
 * schedule one server-side (Flow/Functions don't have cart access), so
 * this is done client-side: a timestamp lives in localStorage, updated
 * on every real cart mutation, and checked once per page load.
 */
(function () {
  var settings = window.cwipCartAutoExpireSettings || {};

  // Defaults (enabled, 24h) apply if the setting is ever missing —
  // e.g. this file loading on a theme/cache version that predates the
  // theme.liquid change wiring it up.
  var enabled = settings.enabled !== false;
  if (!enabled) return;

  var hours = parseFloat(settings.hours);
  if (!(hours > 0)) hours = 24;
  hours = Math.min(hours, 48);

  var STORAGE_KEY = 'cwip_cart_last_activity';
  var EXPIRY_MS = hours * 60 * 60 * 1000;

  function getLastActivity() {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      return val ? parseInt(val, 10) : null;
    } catch (e) {
      return null;
    }
  }

  function touchActivity() {
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (e) {}
  }

  function clearActivity() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  // Every cart mutation in this theme (add to cart, quantity change,
  // remove) ends up calling one of Shopify's own /cart/* endpoints via
  // fetch, regardless of which Alpine component triggered it
  // (handleVariant, handleCart, the mini-cart's own component, or
  // anything added later) — wrapping fetch once here catches all of
  // them without needing to individually touch every call site.
  var CART_MUTATION_PATTERN = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (CART_MUTATION_PATTERN.test(url)) {
      result.then(function (response) {
        if (response && response.ok) touchActivity();
        return response;
      });
    }
    return result;
  };

  // Run once per page load. A cart with no recorded activity yet (first
  // ever visit, or an existing cart from before this script was added)
  // just gets a fresh timestamp instead of being treated as already
  // expired — only a cart that's genuinely gone quiet for 24h+ gets
  // cleared.
  var last = getLastActivity();
  if (last === null) {
    originalFetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) touchActivity();
      })
      .catch(function () {});
  } else if (Date.now() - last > EXPIRY_MS) {
    originalFetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function () {
        clearActivity();
        // Refreshes anything already listening for these (mini-cart
        // badge/drawer, cart page) so a page left open doesn't keep
        // showing the just-cleared items.
        window.dispatchEvent(new CustomEvent('cartupdated'));
        window.dispatchEvent(new CustomEvent('carttotalitems', { detail: 0 }));
      })
      .catch(function () {});
  }
})();
